import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from 'app/core/services/storage.service';
import * as CryptoJS from 'crypto-js';
import { environment } from 'environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'external-login',
  template: '<br>',
  styles: []
})

export class ExternalLogin implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private storageService: StorageService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {

      const encryptedData = params['data'];
      const iv = params['iv'];

      const cryptoSecretKey = CryptoJS.enc.Utf8.parse(environment.cryptoSecretKey);
      const initVector = CryptoJS.enc.Base64.parse(iv);

      const decryptedBytes = CryptoJS.AES.decrypt(encryptedData, cryptoSecretKey, {
        iv: initVector,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      
      const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);
      
      const data = JSON.parse(decryptedText);

      this.storageService.setCurrentSession(data);
    

      this.router.navigate(['/'], { replaceUrl: true })
      .then(
        () => {

        Swal.fire({
          title: 'Bienvenido(a) a Multientrega',
          text: 'Esta es la nueva plataforma para clientes de bancos en Multientrega',
          icon: 'info',
          confirmButtonText: 'Aceptar'
        }); // Swal.fire
      }); // this.router.navigate
    }); // this.route.queryParams.subscribe
  } // ngOnInit

}